export {
  ErrorBoundary as AdminNewCheckpointErrorBoundary,
  Page as AdminNewCheckpointPage,
  loader as adminNewCheckpointLoader
} from './new'
